
<style>
.dot {
  height: 10px;
  width: 10px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}

#alert_changePass{
    background-image: linear-gradient(45deg, #f7827c 15%, #ffffff 82%);
    width: 98%; height: 70%; position: fixed; z-index:100; top:10%; left: 1%; right: 1%;
}


</style>


<template>
  
  <div>
    


    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">



    </base-header>
    
    <!-- <div class="card" id="alert_changePass">
      <div class="card-body"  style=" ">
        <h1 class="card-title"  style="text-align:center;  font-size: 50px;">ประกาศ</h1>
        <p class="card-text" style="font-size: 30px; background-color: white; border: solid;">
          เรียน ลูกค้าคนสำคัญ<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          ตอนนี้รหัสผ่านของท่านหมดอายุแล้ว กรุณาเปลี่ยนรหัสผ่านใหม่
        </p>
        <a v-on:click="goChangePass()" class="btn btn-primary" style="background-image: linear-gradient(45deg, #7950f2 7%, #e6e9eb 100%); color:white; width: 100%; font-size:1em;">แก้ไขรหัสผ่าน</a>
      </div>
    </div> -->
    <!--Charts-->
    <div class="container-fluid mt--7" style="margin-bottom: 1%">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h5 class="text-uppercase text-muted ls-1 mb-1">
                  กราฟแสดงข้อมูลย้อนหลังรายวัน
                </h5>
                <h5 class="h3 mb-0">
                  รายได้รวมทั้งหมด เดือน {{ month }} ปี {{ year }}
                </h5>

                <a href="https://docs.justwash.asia/tutorial/dashboard" style="color: #007aff; font-size: 14px;   font-weight: 400;" target="_blank">View tutorial</a>
              </div>
              <div class="col">


                <select
                  class="form-control"
                  @change="onchangess($event)"
                  v-model="year"
                >
                  <option v-for="item in year_array">
                    {{ item }}
                  </option>
                </select>

                <select
                  class="form-control"
                  @change="onchangess($event)"
                  v-model="month"
                >
                  <option v-for="item in allmonth_arr" :key="item.no" v-bind:value="item.no">
                    {{ item.label }}
                  </option>
                </select>




              </div>
            </div>

            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="redBarCharts.chartData"
            >
            </bar-chart>
          </card>
        </div>
      </div>
    </div>
   <!-- <br /><br /><br /><br /><br /> -->
 
    <!--Charts-->
    <div class="container-fluid mt--0">


<!--       <div class="row" style="margin-top: 1%">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h5 class="text-uppercase text-muted ls-1 mb-1">
                  กราฟแสดงข้อมูลสรุปแบบวัน
                </h5>
                <h5 class="h3 mb-0">ยอดการใช้งานแบบรายวัน [บาท]</h5>
              </div>
            </div>

            <bar-chart
              :height="250"
              ref="barChart"
              :chart-data="dayCharts.chartData"
              style="bg-color: green"
            >
            </bar-chart>
          </card>
        </div>
      </div>
 -->
      <!--Tables-->
      <div class="row mt-4">
        <!-- <div class="col-xl-8 mb-5 mb-xl-0">
                    <page-visits-table></page-visits-table>
                </div>
                <div class="col-xl-4">
                    <social-traffic-table></social-traffic-table>
                </div> -->
        <div class="col-xl-12 mb-5 mb-xl-0">
          <page-visits-table></page-visits-table>
        </div>
      </div>
      <!--End tables-->
    </div>

    <!-- <div class="container-fluid mt--0">
      <div class="row">
        <div class="col-xl-7" style="margin-bottom: 4%">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h5 class="h3 mb-0">รายได้รวมทั้งหมด</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <canvas
                  id="pie"
                  style="max-width: 1000px; max-heigth: 00px; margin: 0 auto"
                  class="chart chart-pie"
                >
                </canvas>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-5">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h5 class="h3 mb-0">ช่องทางชำระเงินทั้งหมด</h5>
              </div>
            </div>

            <div class="row">
              <div class="col-6" v-for="item in all_payment">
                <div class="card">
                  <h5
                    class="card-header"
                    style="
                      width: 100%;
                      border: 1px solid #000000;
                      word-wrap: break-word;
                    "
                  >
                    <span
                      class="dot"
                      v-if="item.enable == 0"
                      style="background-color: gray"
                    ></span>
                    <span
                      class="dot"
                      v-if="item.enable == 1"
                      style="background-color: green"
                    ></span>
                    {{ item.name }}
                  </h5>
                  <div
                    class="card-body"
                    style="border: 1px solid #000000"
                  ></div>
                </div>
                <br />
              </div>
            </div>
          </card>
        </div>
      </div>
    </div> -->
    
  </div>
</template>
<script>
// Charts
// import LineChart from '@/components/Charts/LineChart';
import BarChart from "@/components/Charts/BarChart";

import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
// Tables
import SocialTrafficTable from "./Dashboard/SocialTrafficTable";
import PageVisitsTable from "./Dashboard/PageVisitsTable";

import JwService from "../service/justwash";
import apiService from '../service/api';


import UserProfile from "./UserProfile.vue";

export default {
  components: {
    // LineChart,
    BarChart,
    PageVisitsTable,
    SocialTrafficTable,
    // eslint-disable-next-line vue/no-unused-components
    UserProfile
  },
  data() {
    return {
      status_changepass: false,
      myChart: null,
      cardData: {},
      tableData: null,
      all_payment_enable: [],
      date: {},
      all_payment: [],
      month_array: [],
      year_array: [],
      month: null,
      year: null,
      redBarChart: {
        chartData: {},
      },
      redBarCharts: {
        chartData: {},
      },
      dayCharts: {
        chartData: {},
      },
      allmonth_arr : [
        { no: 1, label: "มกราคม" },
        { no: 2, label: "กุมภาพันธ์" },
        { no: 3, label: "มีนาคม" },
        { no: 4, label: "เมษายน" },
        { no: 5, label: "พฤษภาคม" },
        { no: 6, label: "มิถุนายน" },
        { no: 7, label: "กรกฎาคม" },
        { no: 8, label: "สิงหาคม" },
        { no: 9, label: "กันยายน" },
        { no: 10, label: "ตุลาคม" },
        { no: 11, label: "พฤศจิกายน" },
        { no: 12, label: "ธันวาคม" },
      ]


    };
  },
  async mounted() {
        if (localStorage.getItem("accessToken") !== null) {
          apiService.check();
        }
        

        const d = new Date();
        let this_year = d.getFullYear();
        this.year_array = [this_year,this_year-1,this_year-2]
        this.year = this_year
        this.month = d.getMonth() + 1;



        // this.UserProfile.
        this.getDashboard();
        this.getGraphDay4();
        this.getPerDayChart();
        await this.getPaymentMethod();
        // this.getPaymentRatio();


  },
  methods: {
    test(){
      
     
    },
    onchangess(event) {
      // this.getGraphDay3(
      //   this.month_array[
      //     this.month_array.findIndex(
      //       ({ label }) => label === event.target.value
      //     )
      //   ].no
      // );

      this.getGraphDay4()


    },

    onYearChange(event) {

    }
    ,
    addCommas(nStr) {
      nStr += "";
      let x = nStr.split(".");
      let x1 = x[0];
      let x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    async getGraphDay3(mo) {
      console.log("graphDay3", mo)

      var dt = new Date();
      // var y = dt.getFullYear();
      var y = this.year
      var m = dt.getMonth() + 1;

      var arr = [
        { no: 1, label: "มกราคม" },
        { no: 2, label: "กุมภาพันธ์" },
        { no: 3, label: "มีนาคม" },
        { no: 4, label: "เมษายน" },
        { no: 5, label: "พฤษภาคม" },
        { no: 6, label: "มิถุนายน" },
        { no: 7, label: "กรกฎาคม" },
        { no: 8, label: "สิงหาคม" },
        { no: 9, label: "กันยายน" },
        { no: 10, label: "ตุลาคม" },
        { no: 11, label: "พฤศจิกายน" },
        { no: 12, label: "ธันวาคม" },
      ];
      this.month_array = [];

      for (let index = m - 1; index >= 0; --index) {
        this.month_array.push(arr[index]);
      }

      if (mo == undefined) {
        mo = m;
      }

      // eslint-disable-next-line no-undef
      await axios({
        method: "post",
        url: JwService.getAPI() + "/api/method/justwash.OwnerApi.GetGraphDay3",
        data: { month: mo },
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          this.tableData = response;
          this.date = {
            year: y,
            date: dt,
            month: m,
          };

          var datenums = new Date(y, mo, 0).getDate();
          var datenum = [];
          for (var i = 1; i <= datenums; i++) {
            datenum.push(i);
          }

          this.month =
            this.month_array[
              this.month_array.findIndex(
                ({ no }) => no === response.data.message.date.month
              )
            ].label;
          // console.log(this.month);
          this.date.month = response.data.message.date.month;

          this.redBarCharts.chartData = {
            labels: datenum,
            datasets: [
              {
                label: "รายได้",
                data: response.data.message.graph,
              },
            ],
          };
        })
        .catch((error) => {
          console.log(error);
          this.$isLoading(false)
          this.$router.push("/login");
        });
    },

    async getGraphDay4() {
      console.log("graphDay4", this.month)


      // eslint-disable-next-line no-undef
      await axios({
        method: "post",
        url: JwService.getAPI() + "/api/method/justwash.OwnerApi.GetGraphDay3",
        data: { month: this.month, year : this.year },
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
            // console.log("respsdfasdf")

          var datenums = new Date(this.year, this.month, 0).getDate();
          var datenum = [];
          for (var i = 1; i <= datenums; i++) {
            datenum.push(i);
          }

          this.redBarCharts.chartData = {
            labels: datenum,
            datasets: [
              {
                label: "รายได้",
                data: response.data.message.graph,
              },
            ],
          };

        })
        .catch((error) => {
          console.log(error);
          this.$isLoading(false)
          this.$router.push("/login");
        });
    },



    async getDashboard() {
       this.$isLoading(true)
      // eslint-disable-next-line no-undef
      await axios({
        method: "post",
        url: JwService.getAPI() + "/api/method/justwash.OwnerApi.Dashboard",
        data: {},
        headers: {
          // 'Authorization' : 'Token EHlTakWH6zSU6m6Lh6kvlg'
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.data.message.status == true) {
             this.$isLoading(false)

            this.cardData = response.data.message.data;
            // console.log(this.cardData);
            let t = this.addCommas(this.cardData.bill_profit_no_promptpay);
            let r = this.addCommas(this.cardData.bill_profit_include_promptpay);
            this.cardData.bill_profit_no_promptpay = t;
            this.cardData.bill_profit_include_promptpay = r;
            this.redBarChart.chartData = {
              labels: [
                "มกราคม",
                "กุมภาพันธ์",
                "มีนาคม",
                "เมษายน",
                "พฤษภาคม",
                "มิถุนายน",
                "กรกฎาคม",
                "สิงหาคม",
                "กันยายน",
                "ตุลาคม",
                "พฤศจิกายน",
                "ธันวาคม",
              ],
              datasets: [
                {
                  label: "รายได้",
                  data: response.data.message.data.graph_summary,
                  backgroundColor: "#66CC33",
                },
              ],
            };
            // this.$router.push('/dashboard')
          } else {
            this.$isLoading(false)
            this.$router.push("/login");
          }
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          this.$isLoading(false)
          this.$router.push("/login");
        });
    },
    async getPaymentRatio() {
      // eslint-disable-next-line no-undef
      await axios({
        method: "post",
        url: JwService.getAPI() + "/api/method/justwash.OwnerApi.PaymentRatio",
        data: {},
        headers: {
          // 'Authorization' : 'Token EHlTakWH6zSU6m6Lh6kvlg'
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.data.message.Linepay == undefined) {
            response.data.message.Linepay = 0;
          }
          let label = [];
          let data = [];

          for (const item of this.all_payment_enable) {
            label.push(item.name);
            if (response.data.message[item.name] > 0) {
              data.push(response.data.message[item.name]);
            }
          }

          var ctx = document.getElementById("pie").getContext("2d");

          var chart = new Chart(ctx, {
            plugins: [ChartDataLabels],
            type: "pie",
            data: {
              labels: label,
              datasets: [
                {
                  backgroundColor: ["#003d6a", "#3cb54b", "red"],
                  data: [
                    response.data.message.PromptPay,
                    response.data.message.Linepay,
                  ],
                },
              ],
            },
            options: {
              maintainAspectRatio: true,
              responsive: true,
              rotation: 0,
              legend: false,
              layout: {
                padding: 32,
              },
              plugins: {
                datalabels: {
                  align: "end",
                  anchor: "end",
                  backgroundColor: null,
                  borderColor: null,
                  borderRadius: 4,
                  borderWidth: 1,
                  color: "#777",
                  offset: 16,
                  padding: 0,
                  formatter: function (value, context) {
                    // console.log(value);
                    return (
                      context.chart.data.labels[context.dataIndex] +
                        "\n " +
                        value +
                        " %" || null
                    );
                  },
                  font: function (context) {
                    var width = context.chart.width;
                    var size = Math.round(width / 29);

                    return {
                      weight: "bold",
                      size: size,
                      family: "Helvetica Neue",
                    };
                  },
                },
              },
            },
          });
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          this.$isLoading(false)
          this.$router.push("/login");
          // });
        });
    },
    async getPaymentMethod() {
      // eslint-disable-next-line no-undef
      await axios({
        method: "post",
        url: JwService.getAPI() + "/api/method/justwash.OwnerApi.PaymentMethod",
        data: {},
        headers: {
          // 'Authorization' : 'Token EHlTakWH6zSU6m6Lh6kvlg'
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.all_payment = response.data.message.reverse();
            for (const item of this.all_payment) {
              if (item.enable == 1) {
                this.all_payment_enable.push(item);
              }
            }
          } else {
            this.$isLoading(false)
            this.$router.push("/login");
          }
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          this.$isLoading(false)
          this.$router.push("/login");
        });
    },
    async getPerDayChart() {
      // eslint-disable-next-line no-undef
      await axios({
        method: "get",
        url: JwService.getAPI() +"/api/method/justwash.OwnerApi.GetGraphWeekUsed",
        data: {},
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
       
          let arr = [];
          // console.log(response.data.message);
          for (const item of response.data.message) {
            arr.push( item.sum_per_day)
          }
         
          this.dayCharts.chartData = {
            labels: [
              "อาทิตย์",
              "จันทร์",
              "อังคาร",
              "พุธ",
              "พฤหัสบดี",
              "ศุกร์",
              "เสาร์",
            ],
            datasets: [
              {
                label: " บาท",
                data: arr,
                backgroundColor: "#FF0033",
              },
            ],
          };
        })
        .catch((error) => {
          console.log(error);
          // this.$router.push("/login");
        });
    },
    async goChangePass(){
       this.$router.push("/changepassword2");
    }
  },
};
</script>
<style>
</style>

